<template>
    <div class="todo-table table-list">
        <div class="table-list-title">
            <span class="category">分類</span>
            <span class="description">待辦敘述</span>
        </div>
        <div class="table-list-body">
            <div v-show="loopLimit.length == 0" class="is-empty">0 筆資料</div>
            <ul>
                <li v-for="(item, index) in loopLimit" :key="index" @click="$router.push({name: 'bizTaskMgtDefault', hash: '#待付款'})">
                    <span class="category">{{transTodoListCat(item.category)}}</span>
                    <span v-if="item.category == 'ADD_TASK'" >您有{{item.taskCount}}個委託等待付款</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { apiBizGetTodoListTask } from "@/apis/api.js"; 

export default {
    data () {
        return {
            list: ''
        }
    },
    mounted () {
        this.getTodoListTask()
    },
    props: {
        limit: false 
    },
    watch: {
        filterQuery: {
            handler: function () {
                this.getTodoListTask()
            },
            deep: true
        }
    },
    methods: {
        getTodoListTask : function () {
            let data = {
                county: this.filterQuery.county,
                district: this.filterQuery.district,
                groupId: this.filterQuery.groupId,
                memberId: this.filterQuery.memberId
            }


            apiBizGetTodoListTask(data)
            .then(res => {
                console.log(res)
                if( res.data.status == 'SUCCESS'){
                    this.list = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        translateDate: function (date) {

            let currentDate = new Date(date)
            currentDate = currentDate.setHours(currentDate.getHours())

            return currentDate
        },
    },
    computed: {
        loopLimit: function () {
            if(this.limit){
                return this.list.slice(0, this.limit)
            }else{
                return this.list
            }
        },
        ...mapGetters({
            filterQuery: 'BIZ_TODO_LIST_FILTER_QUERY',
        })
    },
}
</script>
<style lang="scss" scoped>
    .todo-table{
        &.table-list{
            width: 100%;
            border-radius: 0;
            border-left: none;
            border-right: none;
            border-bottom: none;
            box-sizing: border-box;
            .table-list-body ul li{
                align-items: flex-start;
                cursor: pointer;
            }
        }
        .category{
            width: 76px;
            margin-right: 60px;
        }
        .description{
            width: 250px;
            margin-right: 60px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/todoList/todoTask.vue